import utils from './../../utils.js';

export default utils.generateNamespace({
	state: ['NOTIFICATIONS', 'CONFIG', 'COOKIE_STORE', 'NOTIFICATIONS_LISTENERS'],
	actions: ['SEND_NOTIFICATION', 'ADD_LISTENER', 'HANDLE_ERROR'],
	mutations: ['ADD_NOTIFICATION', 'ASSIGN_LISTENER'],
	getters: ['GET_NOTIFICATIONS', 'CONTEXT_PATH', 'IMAGE_PATH', 'GET_COOKIE_STORE']
});



// WEBPACK FOOTER //
// ./src/store/modules/app/namespace.js